"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetDriveParametricSchema = exports.FetDriveParametric = void 0;
const zod_1 = require("zod");
var FetDriveParametric;
(function (FetDriveParametric) {
    FetDriveParametric["OpenDrain"] = "open-drain";
    FetDriveParametric["OpenCollector"] = "open-collector";
    FetDriveParametric["PushPull"] = "push-pull";
})(FetDriveParametric || (exports.FetDriveParametric = FetDriveParametric = {}));
exports.FetDriveParametricSchema = zod_1.z.nativeEnum(FetDriveParametric);
//# sourceMappingURL=FetDriveParametric.js.map